import React from 'react';

import AuthenticationResult from 'Components/Authentication/Reusable/AuthenticationResult.component';
import { APP_ROUTES } from 'Constants/GlobalConstants/Global.constants';

const Failure = (props) => {
  return (
    <AuthenticationResult
      header={{
        type: 'h1',
        content: 'phoneActivation.failure.header',
        translation: true
      }}
      icon={{
        base: 'regular',
        name: 'times-circle',
        color: 'black',
        size: '10x'
      }}
      description={{
        type: 'intro',
        color: 'grey-5',
        content: 'phoneActivation.failure.description',
        translation: true
      }}
      link={{
        to: APP_ROUTES.DASHBOARD,
        bgColor: 'orange-3',
        borderColor: 'orange-3',
        color: 'white',
        content: 'phoneActivation.failure.footer.cta',
        translation: true
      }}
    />
  );
};

export default Failure;
